import Model from 'flarum/common/Model';
import type Post from 'flarum/common/models/Post';
import type User from 'flarum/common/models/User';
import mixin from 'flarum/common/utils/mixin';

class Advcomment extends mixin(Model, {
    content: Model.attribute('content'),
    contentHtml: Model.attribute('contentHtml'),
    user_id: Model.attribute('user_id'),
    post_id: Model.attribute('post_id'),
    created_at: Model.attribute('created_at'),
    isUpVote: Model.attribute('isUpVote'),
    isDownVote: Model.attribute('isDownVote'),
    advcomment_id: Model.attribute('advcomment_id'),
    upvotes: Model.attribute('upvotes'),
    votes: Model.attribute('votes'),
    votesSum: Model.attribute('votesSum'),
    user: Model.hasOne('user'),
    post: Model.hasOne('post'),
    upvotes: Model.hasMany('upvotes'),
    downvotes: Model.hasMany('downvotes'),
    flags: Model.hasMany('flags'),
}) {}

export default class Flag extends Model {
  type() {
    return Model.attribute<string>('type').call(this);
  }
  reason() {
    return Model.attribute<string | null>('reason').call(this);
  }
  reasonDetail() {
    return Model.attribute<string | null>('reasonDetail').call(this);
  }
  advcommentId() {
    return Model.attribute<string | null>('advcommentId').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }

  post() {
    return Model.hasOne<Post>('post').call(this);
  }
  user() {
    return Model.hasOne<User | null>('user').call(this);
  }
  advcomment() {
    return Model.hasOne<Advcomment>('advcomment').call(this);
  }
}
